import rgba from 'assets/theme/function/rgba';

const colors = {
    background: {
        default: '#1F2938',
    },
    common: {
        white: '#FFFFFF',
        black: '#000000',
    },

    primary: {
        main: rgba('#4880FF', 0.5),
        light: rgba('#4880FF', 1),
        dark: '#4484D9',
    },
    secondary: {
        main: '#1A2230',
        light: '#2A374B',
        dark: '#273142',
    },

    error: {
        main: '#FF5959',
        light: '#E53935',
    },

    info: {
        main: '#5A708F',
        light: '#1CFFDD',
        dark: '#4484D9',
    },

    success: {
        main: rgba('#4880FF', 0.4),
        light: '#FF1CFB',
        dark: '#F444AE',
    },

    text: {
        secondary: '#FFFFFF',
    },
    divider: rgba('#d9d9d9', 0.15),

    action: {
        active: '#26A666',
        draft: '#F1D359',
        empty: '#dfbd31',
        selected: '#0E1725',
        light: '#D9D9D9',
        selectedIcon: '#4484D9',
        progress: '#525B94',
        dark: '#20243d',
        button: '#688CDD',
        scroll: '#AFBACA',
        menu: '#29466E',
        menuSelect: '#3C69A8',
        disabled: '#505050',
    },

    grey: {
        100: '#EEEEEE',
        200: '#f2f2f2',
        300: '#38435F',
        400: '#ced4da',
        500: '#a0b1ce',
        600: '#29466E',
        700: '#495057',
        800: '#273243',
        900: '#212529',
    },
    blue: {
        100: '#EEEEEE',
        200: '#f2f2f2',
        300: '#6796C5',
        400: '#8358FF',
        500: '#adb5bd',
        600: '#6c757d',
        700: '#495057',
        800: '#343a40',
        900: '#212529',
    },
};

export default colors;
